import React from "react";
import type { CartItem } from "../types/store";

type Props = {
  items: CartItem[];
  onBackToStore: () => void;
  onIncrease: (key: string) => void;
  onDecrease: (key: string) => void;
  onRemove: (key: string) => void;
  onCheckout: () => void;
};

const CartPage: React.FC<Props> = ({
  items,
  onBackToStore,
  onIncrease,
  onDecrease,
  onRemove,
  onCheckout,
}) => {
  const subtotal = items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
  const vat = subtotal * 0.19;
  const total = subtotal + vat;

  return (
    <div className="ep-storeShell">
      <header className="ep-storeHeader">
        <h1>Cart</h1>
        <p>Review your products and continue to payment.</p>
        <button className="ep-cartBtn ep-cartBtn--ghost" onClick={onBackToStore}>
          Back to store
        </button>
      </header>

      <div className="ep-cartWrap">
        <div className="ep-cartItems">
          {items.length === 0 && <p className="ep-emptyCart">Your cart is empty.</p>}
          {items.map((item) => (
            <article key={item.key} className="ep-cartItem">
              <div>
                <h3>{item.productName}</h3>
                <p>{item.merchantName}</p>
              </div>
              <div className="ep-cartControls">
                <button onClick={() => onDecrease(item.key)}>-</button>
                <span>{item.quantity}</span>
                <button onClick={() => onIncrease(item.key)}>+</button>
              </div>
              <strong>EUR {(item.unitPrice * item.quantity).toFixed(2)}</strong>
              <button className="ep-removeBtn" onClick={() => onRemove(item.key)}>
                Remove
              </button>
            </article>
          ))}
        </div>

        <aside className="ep-cartSummary">
          <h2>Summary</h2>
          <p>
            <span>Subtotal</span>
            <strong>EUR {subtotal.toFixed(2)}</strong>
          </p>
          <p>
            <span>VAT (19%)</span>
            <strong>EUR {vat.toFixed(2)}</strong>
          </p>
          <p className="ep-totalRow">
            <span>Total</span>
            <strong>EUR {total.toFixed(2)}</strong>
          </p>
          <button onClick={onCheckout} disabled={items.length === 0}>
            Pay now
          </button>
        </aside>
      </div>
    </div>
  );
};

export default CartPage;
